/**
 * CMS-side tournament bootstrap types — re-exported from the swagger-gen output
 * (single source of truth) plus portal-URL helpers that have no API counterpart.
 */

export type {
  CmsTournamentResponse,
  CreateCmsTournamentRequest,
  UpdateCmsTournamentRequest,
} from "@/types/generated/cms.generated";

/**
 * The tournament-portal base domain for the current environment: the portal is
 * served per tournament at {slug}.tournament.{domain}. Local/dev CMS hosts point
 * at the dev portal; only the production CMS points at production.
 */
export function tournamentPortalDomain(hostname: string = window.location.hostname): string {
  const isProd = hostname === "cms.athlyn.app";
  return isProd ? "tournament.athlyn.app" : "tournament.dev.athlyn.app";
}

export function tournamentPortalAdminUrl(slug: string, hostname?: string): string {
  return `https://${slug}.${tournamentPortalDomain(hostname)}/admin`;
}
